import { defineComponent as _defineComponent } from 'vue'
import OfferRow from '@/features/buybox/components/grid/OfferRow.vue';
import FastOffer from '@/features/buybox/components/grid/FastOffer.vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { FastOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';

interface FastRowProps {
	title: TitleDetail;
	offers: FastOfferFragment[];
	inline?: boolean;
	trackingContexts?: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FastOfferRow',
  props: {
    title: null,
    offers: null,
    inline: { type: Boolean },
    trackingContexts: { default: () => [] }
  },
  emits: ["clickOut"],
  setup(__props: any) {





return { __sfc: true,OfferRow, FastOffer }
}

})